import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import { SketchPicker } from 'react-color';
import { Popover } from '@material-ui/core';

import { classes } from '../utils';

import styles from './ColorPicker.module.scss';

const ColorPicker = props => {
  const [anchor, setAnchor] = useState(null);
  const [color, setColor] = useState(convert(props.color));

  const { style = {}, onChange, returnType, theme = 'square' } = props;

  useEffect(() => {
    setColor(state => {
      const color = convert(props.color);
      return _.isEqual(color, state) ? state : color;
    });
  }, [props.color]);

  const handleChange = ({ rgb }) => {
    setColor(rgb);

    if (onChange) {
      const { r, g, b, a } = rgb;

      if (returnType === 'hex') {
        onChange(`${toHex(r)}${toHex(g)}${toHex(b)}`);
      } else {
        onChange(`rgba(${r}, ${g}, ${b}, ${a})`);
      }
    }
  };

  return (
    <div className={classes(styles.colorPicker, styles[theme])} style={style.root}>
      <div
        className={styles.swatch}
        style={style.swatch}
        onClick={event => setAnchor(event.currentTarget)}
      >
        <div
          className={styles.color}
          style={{
            ...style.color,
            backgroundColor: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
          }}
        />
      </div>

      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <SketchPicker color={color} onChange={handleChange} />
      </Popover>
    </div>
  );
};

export default ColorPicker;

const hexToRgba = hex => {
  const colorObj = { r: 0, g: 0, b: 0, a: 1 };
  const len = hex.startsWith('#') ? 7 : 6;

  while (hex.length < len) {
    hex += hex.charAt(hex.length - 1);
  }

  try {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(hex);

    if (result) {
      colorObj.r = parseInt(result[1], 16);
      colorObj.g = parseInt(result[2], 16);
      colorObj.b = parseInt(result[3], 16);
      colorObj.a = parseInt(result[4] || 1, 16);
    }
  } catch (err) {}

  return colorObj;
};

const convert = color => {
  if (typeof color === 'string' && !color.startsWith('rgb')) {
    return hexToRgba(color);
  }

  const colorObj = { r: 0, g: 0, b: 0, a: 1 };

  if (color) {
    try {
      const colorComps = color
        .substring(color.indexOf('(') + 1, color.indexOf(')'))
        .split(',');

      colorObj.r = parseInt(colorComps[0]);
      colorObj.g = parseInt(colorComps[1]);
      colorObj.b = parseInt(colorComps[2]);
      colorObj.a = parseFloat(colorComps[3]);
    } catch (err) {}
  }

  return colorObj;
};

const toHex = val => val.toString(16).padStart(2, '0');
